import * as React from 'react';

import { translate } from '~l10n/client';

import HandraiseIconActive from '../../../../shared/icons/HandraiseIconActive';
import HandraiseIconInactive from '../../../../shared/icons/HandraiseIconInactive';
import TeacherIcon from '../../../../shared/icons/TeacherIcon';

interface MobileStudentHeaderMenuProps {
  controller: {
    handraiseClicked: () => void;
    refreshClicked: () => void;
    logOutClicked: () => void;
  };
  handraise: boolean;
  handraiseStatus: boolean;
  userName: string;
}

const MobileStudentHeaderMenu = ({
  controller,
  handraise,
  handraiseStatus,
  userName,
}: MobileStudentHeaderMenuProps) => {
  const { handraiseClicked, refreshClicked, logOutClicked } = controller;

  return (
    <div id="mobile-student-header-menu">
      <ul id="mobile-student-header-items">
        <li className="mobile-student-header-item mobile-student-header-name-row">
          <TeacherIcon className="mobile-header-icon" color="#ccc" />
          <div className="mobile-student-header-name-text">{userName}</div>
        </li>
        <li className="mobile-student-header-item" onClick={refreshClicked}>
          <span>{translate('Refresh')}</span>
        </li>
        {handraiseStatus ? (
          <li className="mobile-student-header-item" onClick={handraiseClicked}>
            <span>
              {handraise ? (
                <>
                  {translate('Lower Hand')}
                  <HandraiseIconActive className="handraise handraise-on" />
                </>
              ) : (
                <>
                  {translate('Raise Hand')}
                  <HandraiseIconInactive className="handraise handraise-off" />
                </>
              )}
            </span>
          </li>
        ) : null}
        <li className="mobile-student-header-item" onClick={logOutClicked}>
          <span>{translate('Log Out')}</span>
        </li>
      </ul>
      <div
        className="app-version"
        key={window.APP_CONFIG.VERSION}
      >{`v${window.APP_CONFIG.VERSION}`}</div>
    </div>
  );
};

export default MobileStudentHeaderMenu;
